import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { Subscription } from 'rxjs';
import { ELoadingIndicatorStyle } from 'projects/shared/lib/enum/loading/loading-indicator-style.enum';
import { EDiscountKind, EDiscountType, EPriceMark } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { PriceTemplateData } from 'projects/shared/lib/components/shared/price/template-data/price-template-data.model';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { LoadingIndicatorComponent } from '../../base/loading-indicator/loading-indicator.component';
import { PriceMissingInfoIconComponent } from '../price-missing-info-icon/price-missing-info-icon.component';
import { PriceFormatComponent } from '../format/price-format.component';

@Component({
  selector: 'app-price-card-price',
  imports: [
    LoadingIndicatorComponent,
    PriceMissingInfoIconComponent,
    PriceFormatComponent
  ],
  templateUrl: './price-card-price.component.html',
  styleUrls: ['./price-card-price.component.scss']
})
export class PriceCardPriceComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public priceTemplateData?: PriceTemplateData;
  public isLoading: boolean;

  public eLoadingIndicatorStyle: typeof ELoadingIndicatorStyle;

  public shouldDisplayPrices: boolean | undefined;
  private authenticationSubscription: Subscription | undefined;

  public eDiscountKind: typeof EDiscountKind;
  public eDiscountType: typeof EDiscountType;
  public ePriceMark: typeof EPriceMark;

  public isUnitPricePricing: boolean = true;

  protected readonly authService: IAuthService;

  public constructor() {
    this.isLoading = true;

    this.eLoadingIndicatorStyle = ELoadingIndicatorStyle;
    this.eDiscountKind = EDiscountKind;
    this.eDiscountType = EDiscountType;
    this.ePriceMark = EPriceMark;

    this.authService = inject(IAuthServiceToken);

    this.shouldDisplayPrices = this.shouldDisplayPricesCurrentStateGet();
  }

  public ngOnInit(): void {
    this.authenticationSubscriptionInit();
    this.isUnitPricePricing = ENVIRONMENT.price.isUnitPricePricing != undefined ? ENVIRONMENT.price.isUnitPricePricing : true;
  }

  private authenticationSubscriptionInit() {
    if (!this.authenticationSubscription) {
      this.authenticationSubscription = this.authService.authenticatedGet().subscribe(
        () => {
          this.shouldDisplayPrices = this.shouldDisplayPricesCurrentStateGet();
        }
      );
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      switch (propName) {
        case 'priceTemplateData':
          this.isLoading = false;
          break;
        default:
          this.isLoading = false;
          break;
      }
    }
  }

  public ngOnDestroy(): void {
    this.authenticationSubscription?.unsubscribe();
    this.isLoading = false;
  }

  protected shouldDisplayPricesCurrentStateGet(): boolean | undefined {
    return ENVIRONMENT.price.allowAnonymousPrice || this.authService.isAuthenticated();
  }

}
